import React from "react"

export default function LineChartIcon(props) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.872559 0.937988V16.0135C0.872559 16.5927 1.34209 17.0622 1.92129 17.0622H17.1279" stroke="#344054" stroke-width="1.5731" stroke-linecap="round"/>
            <path d="M2.97021 11.0322L8.42178 5.45381C8.52381 5.34941 8.69146 5.34845 8.79468 5.45167L12.2291 8.8861C12.3292 8.98623 12.4908 8.98875 12.594 8.8918L16.7348 5.00195" stroke="#344054" stroke-width="1.5731" stroke-linecap="round"/>
        </svg>
    )
}